/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemFinancialsSchema = z.object({
  budgetAmount: z.string().describe('Budget amount for this item').nullish(),
  capexPercentage: z.number().describe('CapEx percentage for this item').nullish(),
  forecastRevenueAmount: z.string().describe('Forecast revenue amount for this item').nullish(),
  itemId: z.int().describe('Item id'),
  updatedAt: z.iso.datetime().describe('When these financial values were last updated'),
  updatedBy: z.string().describe('User who last updated these financial values'),
});
